import { AppBar, Box, IconButton, Menu, MenuItem, Tooltip, Typography } from '@mui/material'
import { theme } from 'config'
import { Modal } from './common/modal'
import { inject, observer } from 'mobx-react'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { Pages } from 'routes'
import { AuthStore, RoutingStore } from 'stores'
import styled from 'styled-components'
import { Icon } from './icon'
import { FeedbackForm } from 'views/settings/feedbackForm'

const MenuTrigger = styled(Box)`
  cursor: pointer;
`

type TopBarProps = {
  authStore?:      AuthStore,
  routingStore?:   RoutingStore,
  showBackButton?: boolean,
  title?:          string,
  onBack?():       void,
}

export const Topbar = inject('authStore', 'routingStore')(observer((props: TopBarProps): JSX.Element => {
  const { authStore, routingStore, showBackButton, title, onBack } = props;
  const { t } = useTranslation();
  const [userMenuEl, setUserMenuEl] = React.useState<null | HTMLElement>(null);
  const [openModal,  setOpenModal]  = React.useState<boolean>(false);
  const menuOpen = Boolean(userMenuEl);

  return (
    <AppBar
      position = 'sticky'
      sx       = {{
        width: {sm: `calc(100% - ${theme.drawerWidth})`, xs: '100%'},
        ml:    {sm: `${theme.drawerWidth}`, xs: 0},
      }}
    >
      <Box
        display        = 'flex'
        alignItems     = 'center'
        justifyContent = {showBackButton || title ? 'space-between' : 'flex-end'}
      >
        {showBackButton && (
          <MenuTrigger
            display    = 'flex'
            alignItems = 'center'
            gap        = {1}
            p          = {1}
            onClick    = {() => onBack ? onBack() : routingStore.goBack()}
          >
            <Icon iconId='arrow-left' />
            {t('back')}
          </MenuTrigger>
        )}
        {title && <Typography variant='h3'>{title}</Typography>}
        <Box display='flex' gap={1}>
        <Tooltip placement='left' title={t('fab_send_feedback')as string}>
          <IconButton
            onClick ={() => setOpenModal(true)}
          >
            <Icon size='size-24' iconId='feedback'/>
          </IconButton>
        </Tooltip>
        
        <MenuTrigger
          display    = 'flex'
          alignItems = 'center'
          gap        = {1}
          p          = {1}
          onClick    = {(e) => setUserMenuEl(e.currentTarget)}
        >
          <Icon iconId='user' size='size-24' />
          {authStore.getCurUser.first_name}
          <Icon iconId='chevron-down' size='size-24' />
        </MenuTrigger>

        <Menu
          disableAutoFocusItem
          id            = 'user-menu'
          anchorEl      = {userMenuEl}
          open          = {menuOpen}
          onClose       = {() => setUserMenuEl(null)}
          MenuListProps = {{
            'aria-labelledby': 'basic-button',
          }}
        >
          <MenuItem
            onClick={() => routingStore.push(Pages.Settings)}
          >
            {t('account')}
          </MenuItem>
          <MenuItem onClick={() => authStore.logout()}>
            {t('logout')}
          </MenuItem>
        </Menu>
      </Box>

        <Modal open={openModal} onClose={() => setOpenModal(false)}>
        <FeedbackForm
          onCancel = {() => setOpenModal(false)}
          onSend   = {async (message) => {return await props.authStore.submitFeedback(message)}}
        />
      </Modal>
      </Box>
    </AppBar>
  );
}));
